//src/styles/components/MuiTextInput.js

import shape from "../shape";

const MuiTextInput = {
  styleOverrides: {
    root: ({ theme }) => ({
      // Your TextField theme overrides
      '& .MuiInputBase-root': {
        borderRadius: shape.borderRadiusSm,
      },
    }),
  },
  defaultProps: {
    fullWidth: true,
    variant: 'outlined',
  },
};

export default MuiTextInput;